/**
 * Normalizza qualsiasi valore in un array di stringhe.
 * - null/undefined -> []
 * - string[] -> sé stesso
 * - string -> [string]
 * - altro -> [String(value)]
 */
export function normalizeToStringArray(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) return value.map((v) => (typeof v === "string" ? v : String(v))).filter((v) => v.length > 0);
  if (typeof value === "string") return value.length > 0 ? [value] : [];
  return [String(value)];
}
